import type { CreateStackletData, Stacklet } from '@/entities/stacklet';
import request from '@/shared/api/request';

export const createStacklet = (data: CreateStackletData): Promise<{ stacklet: Stacklet }> =>
  request({
    url: '/stacklets/',
    method: 'POST',
    data,
  });
